import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

export const useCreateInstructionForPharmacist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DrugsApi.createInstructionForPharmacist,
    onSuccess: async (_, params) => {
      await queryClient.invalidateQueries(DrugsQueryKeys.getInstructionForPharmacist(params.drugId));
    },
  });
};
